<template>
  <section class="google-auth-modal">
    <div class="ine-card google-auth-modal__wrapper">
      <div class="google-auth-modal__wrapper-overlay"></div>
      <div class="google-auth-modal__header">
        <XIcon
          class="google-auth-modal__header-icon google-auth-modal__header-icon--close"
          @click="closeModal()"
        />
      </div>
      <h1 class="google-auth-modal__title">
        Google Authenticator
      </h1>
      <div class="google-auth-modal__steps">
        <StepQR
          v-if="this.currentStep === 1"
          :gaQrCode="gaQrCode"
          @go-next-step="goNextStep()"
        />
        <DigitCodeInput
          v-if="this.currentStep === 2"
          :gaQrCode="gaQrCode"
          :isModal="true"
          @is-digit-code-loading="isDigitCodeLoadingHandler"
          @go-prev-step="goPrevStep()"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { XIcon } from 'vue-feather-icons'
import StepQR from '@/components/modals/google-authenticator/GoogleAuthenticatorQR.vue'
import DigitCodeInput from '@/components/shared/DigitCodeInput.vue'

export default {
  name: 'GoogleAuthenticatorModal',
  components: {
    XIcon,
    StepQR,
    DigitCodeInput,
  },
  data() {
    return {
      isLoading: false,
      isLoadingComponent: false,
      currentStep: 1,
    }
  },
  props: {
    gaQrCode: {
      type: String,
      required: true,
    },
  },
  methods: {
    goPrevStep() {
      if (this.currentStep > 0) this.currentStep -= 1
    },
    goNextStep() {
      if (this.currentStep < 2) this.currentStep += 1
    },
    setLoader(loaderState) {
      this.isLoading = loaderState
    },
    isDigitCodeLoadingHandler(state) {
      this.isLoadingComponent = state
    },
    closeModal() {
      if (!this.isLoadingComponent) this.$emit('close-ga-modal')
    },
  },
  async created() {
    const body = document.querySelector('body')
    body.classList.add('modal-open')
  },
  destroyed() {
    const body = document.querySelector('body')
    body.classList.remove('modal-open')
  },
}
</script>
